module.exports = __webpack_public_path__ + "static/media/collection.ea755b3e.svg";